import { render, staticRenderFns } from "./SpecInfo.vue?vue&type=template&id=2b277abe&"
import script from "./SpecInfo.vue?vue&type=script&lang=js&"
export * from "./SpecInfo.vue?vue&type=script&lang=js&"
import style0 from "./SpecInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports